<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="deliveryErrorInternationalForm!">
    <h2 class="text-base font-bold text-font-primary">Additional Information</h2>
    <div class="mt-4 flex flex-col gap-4">
        @switch (deliveryErrorInternationalForm?.controls?.issueType?.value) { @case
        (deilveryErrorType.DELIVERED_TO_WRONG_ADDRESS) {
        <sag-ui-radio-group
            label="Does Delivery Documentation match the incorrect delivery address?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio
                name="deliveryDocumentationMatchesAddress"
                formControlName="deliveryDocumentationMatchesAddress"
                [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio
                name="deliveryDocumentationMatchesAddress"
                formControlName="deliveryDocumentationMatchesAddress"
                [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>

        <sag-ui-input
            [required]="true"
            label="To which address was the shipment incorrectly delivered?"
            formControlName="addressShippedTo"
            class="max-w-input"
        ></sag-ui-input>

        } @case (deilveryErrorType.DELIVERED_TO_WRONG_PORT) {
        <sag-ui-radio-group
            label="Does Delivery Documentation match the incorrect Port of delivery?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio
                name="deliveryDocumentationMatchesPort"
                formControlName="deliveryDocumentationMatchesPort"
                [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio
                name="deliveryDocumentationMatchesPort"
                formControlName="deliveryDocumentationMatchesPort"
                [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>

        <sag-ui-input
            label="To which Port of Entry was the shipment incorrectly delivered?"
            formControlName="portShippedTo"
            class="max-w-input"
        ></sag-ui-input>

        } @case (deilveryErrorType.DELIVERED_BY_WRONG_CARRIER) {
        <sag-ui-input
            label="Which Carrier incorrectly delivered this shipment?"
            formControlName="carrier"
            class="max-w-input"
        ></sag-ui-input>

        } @case (deilveryErrorType.ATELLICA_INVENTORY_MANAGER) {
        <sag-ui-select
            [required]="true"
            label="AIN Error Type"
            placeholder="Select AIN Error Type"
            formControlName="ainErrorType"
            class="max-w-input"
        >
            @for (item of ainErrorTypes | keyvalue; track $index) {
            <sag-ui-option [value]="item.value">{{ item.value }}</sag-ui-option>
            }
        </sag-ui-select>

        <sag-ui-radio-group label="Is a replacement Order required?" direction="row" [required]="true">
            <sag-ui-radio name="replacementOrderRequired" formControlName="replacementOrderRequired" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="replacementOrderRequired" formControlName="replacementOrderRequired" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>

        @if (isTrue('replacementOrderRequired')) {
        <sag-ui-input
            label="Replacement Order Number"
            formControlName="replacementOrderNumber"
            class="max-w-input"
        ></sag-ui-input>
        } }} @if (showShippmentNumber()) {
        <sag-ui-input
            [required]="true"
            label="TU / Shipment Number"
            placeholder="Enter TU / Shipment Number"
            formControlName="shipmentNumber"
            class="max-w-input"
        ></sag-ui-input>
        }

        <app-attachments-input
            label="Attach a copy of the Delivery Documentation"
            [form]="deliveryErrorInternationalForm!"
            [required]="true"
            controlName="deliveryDocumentation"
        />

        <sag-ui-textarea
            [required]="true"
            label="Provide any additional information that will aid the Root Cause Investigation"
            placeholder="Provide any relevant details about the issue"
            formControlName="additionalInfo"
            class="max-w-input"
        ></sag-ui-textarea>

        <app-attachments-input
            label="Attach any additional supporting  documentation"
            [form]="deliveryErrorInternationalForm!"
            [required]="true"
            controlName="supportDocumentation"
        />

        <sag-ui-select
            [required]="true"
            label="Financial Adjustment Request?"
            placeholder=""
            formControlName="financialAdjustment"
            class="max-w-input"
        >
            @for (financialAdjustment of financialAdjustments() | keyvalue; track $index) {
            <sag-ui-option [value]="financialAdjustment.value">{{ financialAdjustment.value }}</sag-ui-option>
            }
        </sag-ui-select>
        <app-attachments-input [form]="deliveryErrorInternationalForm!" controlName="relatedDocuments" />
        <div class="flex justify-end max-w-input">
            <sag-ui-button [disabled]="!isValid()" (click)="handleConfirm()" size="sm">Confirm</sag-ui-button>
        </div>
    </div>
</section>
